import crudActions from './crudActions';


export const { fetchUsers, createUser, updateUser, deleteUser } = crudActions('user');
